export const privacyTextLastUpdated = '28 June 2025';

export const privacyText = `
# Privacy Policy

Effective Date: ${privacyTextLastUpdated}

Welcome to Crafty Smile! Your privacy is important to us, 
and we are committed to protecting your personal data. 
This Privacy Policy explains how we collect, use, store, 
and share your information when you use our services.

## 1. Data Collection

1. Personal Data - We collect personal information necessary for providing our services, including:
    - Name
    - Email address
    - Details about the products you sell, such as images, prices, and categories

2. Channel and Usage Data - When you connect your e-commerce accounts (e.g., Etsy), we may collect:
    - Information from connected e-commerce channels
    - IP addresses
    - Browser type and visit times
    - Log data from interactions with our service

3. Methods of Data Collection - We collect data through:
    - Direct input from users
    - Permissions granted to access third-party services like Etsy
    - Automated tracking via cookies, log files, and device information

## 2. Data Use

We use the collected data for:

  - Processing orders and managing accounts
  - Sending important updates and notifications
  - Connecting services for seamless integration
  - Improving our platform and user experience
  - Responding to user inquiries and support requests

Your data may be stored or processed outside your country, including in the UK, 
in compliance with data protection regulations.

## 3. Data Sharing

We share data only under the following conditions:

  - With your consent: To enable service functionality and advertising
  - For advertising: With partners like Google and Meta for advertising optimization
  - Legal requirements: To comply with law enforcement, legal obligations, or business transactions such as mergers or acquisitions

## 4. Data Storage

  - Your data is stored securely with Google Cloud Platform in London.
  - Data is retained for 10 years unless a deletion request is made earlier.

## 5. Marketing Preferences

  - Users can opt-in to receive newsletters.
  - Otherwise, emails are sent only for notifications, product updates, or maintenance.
  - We do not sell or trade your data with third parties

## 6. User Rights and Choices

Under UK and EU data protection laws, you have the right to:

  - Access, modify, or delete your data
  - Restrict or object to data processing
  - Request data portability under applicable conditions

You can exercise these rights by contacting us via our website's contact form.

## 7. Children’s Privacy

Crafty Smile is not intended for users under 18. We do not knowingly collect data from minors.

## 8. Policy Changes

We may update this Privacy Policy. Any changes will be posted on our website, 
and continued use of our services implies acceptance of the revised policy.

## 9. Other services

We use other services to help us provide our services.

- Microsoft Clarity: We use Microsoft Clarity to help us understand how you use our website. You can learn more about how Microsoft Clarity collects and uses data in their [Privacy Policy](https://clarity.microsoft.com/terms).

## 10. Contact Information

For any privacy concerns or to exercise your rights, 
please contact us via the contact form on our website.

We are committed to transparency and protecting your privacy while you use Crafty Smile. 
Thank you for trusting us with your data!

`;
